export enum AccountTypeEnum {
  ADMIN = 0,
  CREATOR = 1,
}
